import { render } from "./Sensor.vue?vue&type=template&id=72a8d1ca&scoped=true"
import script from "./Sensor.vue?vue&type=script&lang=js"
export * from "./Sensor.vue?vue&type=script&lang=js"

import "./Sensor.vue?vue&type=style&index=0&id=72a8d1ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a8d1ca"]])

export default __exports__